import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import './CashTransactionModal.css';

function CashTransactionModal({ onClose, onConfirm, type }) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [description, setDescription] = useState('');

  const reasons = [
    'cashRegister.reasons.openingChange',
    'cashRegister.reasons.supplierPayment',
    'cashRegister.reasons.withdrawal',
    'cashRegister.reasons.correction',
    'cashRegister.reasons.other',
  ];

  const handleSubmit = () => {
    if (!amount || parseFloat(amount) <= 0) return;

    const finalReason = reason === 'cashRegister.reasons.other' ? customReason : t(reason);

    onConfirm({
      type,
      amount: parseFloat(amount),
      reason: finalReason,
      description,
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{type === 'IN' ? t('cashRegister.income') : t('cashRegister.expense')}</h2>
          <button type="button" className="close-btn" onClick={onClose}>
            <Icon name="close" />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>{t('cashRegister.amount')}</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0.00"
              min="0"
              step="0.01"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>{t('cashRegister.reason')}</label>
            <select value={reason} onChange={(e) => setReason(e.target.value)}>
              <option value="">{t('cashRegister.selectReason')}</option>
              {reasons.map((r) => (
                <option key={r} value={r}>
                  {t(r)}
                </option>
              ))}
            </select>
          </div>

          {reason === 'cashRegister.reasons.other' && (
            <div className="form-group">
              <label>{t('cashRegister.customReason')}</label>
              <input
                type="text"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder={t('cashRegister.customReasonPlaceholder')}
              />
            </div>
          )}

          <div className="form-group">
            <label>{t('cashRegister.notes')}</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className={`btn ${type === 'IN' ? 'btn-success' : 'btn-danger'}`}
            onClick={handleSubmit}
            disabled={
              !amount || !reason || (reason === 'cashRegister.reasons.other' && !customReason)
            }
          >
            {t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CashTransactionModal;
